export class ResourceDetailsDto {
    ResourceId: number;
    GPN: string;
    GUI: string;
    ResourceName: string;
    ResourceEmail: string;
    IncludeDummyResources: boolean;
    ResourceStatus: string;
    ResourceType: string;
    ServicelineId: number;
    ServiceLine: string;
    SubServiceLineId: number;
    SubServiceLine: string;
    CompetencyId: number;
    Competency: string;
    CostcenterId: number;
    CostCenter: string;
    CountryId: number;
    Country: string;
    LevelId: number;
    Level: string;
    RankID: number;
    Rank: string;
    GradeId: number;
    Grade: string;
    CompanyCodeId: number;
    CompanyCode: string;
    EconomicLocationId: number;
    EconomicLocation: string;
    OffliceLocationId: number;
    OffliceLocation: string;
    CouncellorName: string;
    EmployeeDepartmentId: number;
    EmployeeDepartment: string;
    EmployeeDepartmentCode: string;
    GDSRegionAllignmentId: number;
    GDSRegionAllignment: string;
    SubAreaId: number;
    SubAreaName: string;
}